import { z } from "zod";

export const SlackTeamInfoSchema = z.object({
  id: z.string(),
  name: z.string()
});
export type SlackTeamInfo = z.infer<typeof SlackTeamInfoSchema>;
